"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardStepByStep = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var steps_1 = tslib_1.__importDefault(require("antd/es/steps"));

var __1 = require("..");

exports.CardStepByStep = function (_ref) {
  var className = _ref.className,
      number = _ref.number,
      label = _ref.label,
      subLabel = _ref.subLabel;
  return React.createElement("div", {
    className: "clp-card-step-by-step ".concat(className ? className : '')
  }, number !== undefined && React.createElement("div", {
    className: 'mr-20'
  }, React.createElement(steps_1["default"], {
    initial: number - 1,
    current: number - 1,
    direction: 'vertical'
  }, React.createElement(__1.Step, null))), React.createElement("div", null, React.createElement("div", {
    className: 'clp-card-step-by-step--sub-label'
  }, subLabel), React.createElement("div", {
    className: 'clp-card-step-by-step--label'
  }, label)));
};